const translations = {
  "en": {
    ".": ".",
    "Across cash, investing, goals, and the years ahead.": "Across cash, investing, goals, and the years ahead.",
    "Cash": "Cash",
    "Caught a better savings rate": "Caught a better savings rate",
    "Come back to clarity, not catch-up.": "Come back to clarity, not catch-up.",
    "Decisions": "Decisions",
    "Down payment": "Down payment",
    "Filtered out 12 distractions": "Filtered out 12 distractions",
    "Finally, a": "Finally, a",
    "Get Started": "Get Started",
    "Hi — I'm Ed. From here on I keep an eye on your money, so you don't have to.": "Hi — I'm Ed. From here on I keep an eye on your money, so you don't have to.",
    "I keep working while you're away.": "I keep working while you're away.",
    "I keep your goals moving forward.": "I keep your goals moving forward.",
    "I watch your": "I watch your",
    "Investing": "Investing",
    "money person": "money person",
    "Moved you 4% closer to your goal": "Moved you 4% closer to your goal",
    "Nothing slips.": "Nothing slips.",
    "on your side.": "on your side.",
    "Retirement": "Retirement",
    "Safety net": "Safety net",
    "Set the goal. I'll build the plan.": "Set the goal. I'll build the plan.",
    "since you last opened": "since you last opened",
    "things I handled": "things I handled",
    "Wealth": "Wealth",
    "whole money life": "whole money life"
  },
  "zh-tw": {
    ".": "。",
    "Across cash, investing, goals, and the years ahead.": "涵蓋現金、投資、目標與長期規劃。",
    "Cash": "現金",
    "Caught a better savings rate": "發現你的儲蓄率提升",
    "Come back to clarity, not catch-up.": "回歸清晰策略，勿盲目追單。",
    "Decisions": "決策",
    "Down payment": "頭款",
    "Filtered out 12 distractions": "已過濾 12 則干擾資訊",
    "Finally, a": "終於，一款",
    "Get Started": "開始",
    "Hi — I'm Ed. From here on I keep an eye on your money, so you don't have to.": "嗨 — 我是 Ed。從現在起，你的錢我幫你盯著，你不用操心。",
    "I keep working while you're away.": "即使你暫時離開，我仍會持續運作。",
    "I keep your goals moving forward.": "我會持續推進你的目標。",
    "I watch your": "追蹤你的",
    "Investing": "投資",
    "money person": "理財人士",
    "Moved you 4% closer to your goal": "已推進目標進度 4%",
    "Nothing slips.": "絕不遺漏。",
    "on your side.": "在你這邊。",
    "Retirement": "退休",
    "Safety net": "安全網",
    "Set the goal. I'll build the plan.": "設定目標。我將為你擬定計畫。",
    "since you last opened": "自你上次開啟以來",
    "things I handled": "已處理事項",
    "Wealth": "財富",
    "whole money life": "理財人生"
  }
};

export default translations;
